<template>
    <framework>
        <template #side>
            <side-panel-nav :registration="registration" v-if="!loading"/>
        </template>
        <template #main>
            <div class="content-frame content pl-5 pt-6" v-if="loading">
                <h4 class="has-text-white"><i class="fas fa-spinner fa-spin mr-4"></i>Please wait. Loading content...</h4>
            </div>

            <template v-else>
                <main-header :title="registration.conference.title" icon="fa-presentation" close="Close Conference" :closeRoute="{name: 'registrations'}"/>
                <router-view/>
            </template>
        </template>
    </framework>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import MainHeader from "../../components/framework/MainHeader";
    import Framework from "../../components/framework/Framework";
    import SidePanelNav from "../../components/conference/ConfSideNav";
    import {client as http} from "../../http_client";

    export default {
        components: {Framework, SidePanelNav, MainHeader},
        props: ['registrationId'],
        computed: {
            ...mapGetters(['currentUser', 'registration'])
        },
        data: function() {
            return {
                loading: true
            };
        },
        methods: {
            ...mapActions(['getRegistrationById']),
            load: function() {
                if (!this.registration || this.registration.id !== parseInt(this.registrationId)) {
                    console.log('Did not find registration in store or id changed. Loading from server.');

                    this.getRegistrationById(this.registrationId).then((enroll) => {
                        this.loading = false;
                    }).catch(err => {
                        console.log(err);
                    });
                } else {
                    this.loading = false;
                }
            }
        },
        mounted() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>

</style>
